import { Channel, buildLivePreviewUrl, getLauncherUrls } from '../utils';
import { sendProStudioEvent } from '../xstate/app.xstate';

type Translate = (key: string, options: { defaultValue: string }) => string;

/**
 * The Channels list's per-channel actions, shared with the Design stage's
 * channel panel so both surfaces do exactly the same thing.
 */

export const generateEmbedScript = (appId: string, env: 'live' | 'sandbox') => {
  const launcherUrl = getLauncherUrls(window.location.origin)[env];

  return `
<script>
  window.pypestreamConfig = {
    APP_ID: '${appId}',
    first_name: '', // TODO: Input user's first name
    last_name: 'Visitor', // TODO: Input user's last name
    phone: '', // TODO: Input user's phone number
    email: '', // TODO: Input user's email address
    screen_name: 'Screen 1', // TODO: Input user's landing page
    token: '', // TODO: Input user token
    passthrough: '', // TODO: Pass any additional data
    language: 'en',
    play_chime: false
  };

  function insertScript () {
    var script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = '${launcherUrl}/launcher.js?ts=' + Date.now();
    script.async = true;
    document.body.appendChild(script);
  }

  if (document.readyState === 'complete') {
    insertScript();
  } else {
    window.addEventListener('load', insertScript);
  }
</script>
`;
};

export const previewChannel = (channel: Channel) => {
  if (!channel.env) return;
  window.open(
    buildLivePreviewUrl(window.location.origin, channel.env, channel.id),
    '_blank'
  );
};

export const copyAppId = (channel: Channel, t: Translate) =>
  sendProStudioEvent({
    type: 'copyToClipboard',
    value: channel.id,
    message: t('pro-studio/channels:toasts.appIdCopied', {
      defaultValue: 'App ID has been copied to your clipboard.',
    }),
  });

export const copyEmbedCode = (channel: Channel, t: Translate) =>
  sendProStudioEvent({
    type: 'copyToClipboard',
    value: generateEmbedScript(channel.id, channel.env),
    message: t('pro-studio/channels:toasts.embedCodeCopied', {
      defaultValue: 'Embed code has been copied to your clipboard.',
    }),
  });

/** The channel's own settings page — voice channels have a separate one. */
export const channelSettingsPath = (
  projectId: string | undefined,
  botId: string | undefined,
  channel: Channel
) =>
  channel.type === 'twilio_voice'
    ? `/${projectId}/${botId}/voice-channel/${channel.id}`
    : `/${projectId}/${botId}/channels/${channel.id}`;
